import { path } from 'ramda'
import { i18n } from '@/i18n'
const Cache = new Map()

const LeadPathByModel = {
  Project: 'project',
  Page: 'page',
  ResidentialTemplate: 'residential-template',
}

function getListLabel(onModel) {
  if (onModel === 'ResidentialTemplate') return i18n.tc('unitCatalog', 1)
  if (onModel === 'Page') return i18n.tc('page', 2)
  return i18n.tc('project', 2)
}

function getSitemap({ id, onModel }) {
  if (onModel === 'ResidentialTemplate') return
  if (Cache.has(id)) return Cache.get(id)

  const promise = fetch(`/api/${LeadPathByModel[onModel]}/${id}/sitemap`).then(res => res.json())
  Cache.set(id, promise)

  return promise
}

async function getSitemapEntry(reference, e) {
  const target = /https?:\/\//.test(e) ? new URL(e).pathname : e

  const sitemap = await getSitemap(reference)
  if (!sitemap) return

  return sitemap.entries.find(s => {
    if (s.reference === e) return true

    const url = new URL(s.url)
    if (url.pathname === target) return true

    return false
  })
}

export { getSitemap, getSitemapEntry, getListLabel, LeadPathByModel }
